import {AbstractFilter} from './AbstractFilter';
import {JsonClassType, JsonCreator, JsonProperty} from '@outfoxx/jackson-js';
import {JsonClassTypeOptions} from '@outfoxx/jackson-js/dist/@types';
import {FilterValueInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter/Value/FilterValueInterface';
import { Utils } from "modules/spravochnik/dt-front-page-generator/src/Search/Utils";

class Value implements FilterValueInterface {
    private _selected: Array<Option>;

    constructor(
        private options: Array<Option>
    ) {
        this._selected = [];
    }

    isSelectAll(): boolean {
        return this._selected.length === this.options.length;
    }

    isSelect(option: Option): boolean {
        return this._selected.find((opt: Option) => opt.id === option.id) == undefined;
    }

    toggleSelectAll() {
        if (this.isSelectAll()) {
            this._selected = [];
        } else {
            this._selected = [];
            for (const option of this.options) {
                this._selected.push(option);
            }
        }
    }

    toggle(option: Option) {
        const state = this._selected.find((opt: Option) => opt.id === option.id) == undefined;
        if (state) {
            this._selected.push(option);
        } else {
            this._selected = this._selected.filter((opt: Option) => opt.id !== option.id);
        }
    }

    get selected(): Array<Option> {
        return this._selected;
    }

    reset(): void {
        this._selected = [];
    }

    countValues(): number {
        return this._selected.length;
    }

    toServerParam(): any {
        const list = this._selected.map((option: Option) => option.id);
        return list.length > 0 ? list : null;
    }

    setGetParam(value: any): void {
        if (typeof value !== 'string') {
            return;
        }

        for (const optionId of value.split('|')) {
            const option = this.options.find((opt: Option) => opt.id === optionId);
            if (!option) {
                continue;
            }

            this._selected.push(option);
        }
    }

    toGetParam(): any {
        return this._selected.map((opt: Option) => opt.id).join('|');
    }
}

export class Option {
    readonly id: string;
    readonly value: string;

    constructor(id: string, value: string) {
        this.id = id;
        this.value = value;
    }
}

export class ChoiceFilter extends AbstractFilter<Value> {
    private readonly _options: Map<string, string>;

    private readonly _value: Value;

    constructor(id: string, label: string, options: Map<string, string>|Array<Option>) {
        super(id, label);
        if (options instanceof Map) {
            this._options = options;
        } else {
            this._options = new Map();
            for (const option of options) {
                this._options.set(option.id, option.value);
            }
        }
        this._value = new Value(this.options);
    }

    @JsonCreator()
    static create(
        @JsonProperty()
        id: string,
        @JsonProperty()
        label: string,
        @JsonProperty({value: 'options'})
        @JsonClassType(<JsonClassTypeOptions>{type: () => [Map, [String, String]]})
        options: Map<string, string>
    ) {
        return new ChoiceFilter(id, label, options);
    }

    hasValue(): boolean {
        return this._value.selected.length > 0;
    }

    get value(): Value | null {
        return this._value;
    }

    get options(): Array<Option> {
        const options = [];
        for (const option of this._options || []) {
            options.push(new Option(option[0], option[1]))
        }

        return options;
    }

    filter(query: string): Array<Option> {
        return this.options.filter((option: Option): boolean => {
            return Utils.like(option.value, query);
        });
    }

    reset(): void {
        this.value.reset();
    }
}
